import { Stack, Typography } from '@customink/pigment-react';
import { useAuthUser } from '~/contexts/Auth/AuthContext';

export function Impersonate() {
    const user = useAuthUser();
    if (!user.impersonated) {
        return null;
    }
    return (
        <Stack direction="row" spacing={2} alignItems="baseline">
            <Typography variant="captionRegular">IMPERSONATING</Typography>
            <Typography variant="bodyLong2" sx={{ fontWeight: 'bold' }}>
                {user.email}
            </Typography>
        </Stack>
    );
}
